import { Controller } from "@hotwired/stimulus"
import { application } from "src"

application.register("disable-auxiliary-mouse-buttons-interactions", class extends Controller {
  connect() {
    this.disableClick();
  }

  disconnect() {
    this.enableClick();
  }

  disableClick() {
    this.element.addEventListener("auxclick", this.onAuxClick);
    this.element.addEventListener("mousedown", this.onMouseDown);
    this.element.addEventListener("contextmenu", this.onContextMenu);
    this.element.addEventListener("click", this.onClick);
  }

  enableClick() {
    this.element.removeEventListener("auxclick", this.onAuxClick);
    this.element.removeEventListener("mousedown", this.onMouseDown);
    this.element.removeEventListener("contextmenu", this.onContextMenu);
    this.element.removeEventListener("click", this.onClick);
  }

  // Modern browsers (Chrome, Edge, Opera) use `auxclick` for the middle-click
  onAuxClick = (event) => {
    if (event.button === 1) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  // Firefox (and some others) do not have `auxclick`, so we use `mousedown` for the middle-click
  onMouseDown = (event) => {
    if (event.button === 1) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  // Blocks the context menu (right-click → “Open link in new tab”)
  onContextMenu = (event) => {
    event.preventDefault();
    event.stopPropagation();
  }

  // Blocks Ctrl+Click / Command+Click (open link in new tab)
  // and Shift+Click (sometimes opens in a new window)
  onClick = (event) => {
    if (event.ctrlKey || event.metaKey || event.shiftKey) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
});
